import { QUERY_KEYS } from 'api/query-keys';
import { sharedWorkforceService } from 'api/services';
import { EmployeeResponse } from 'api/services/workforce/workforce-service.types';
import { useQuery } from 'react-query';
import { CACHE_TIME_LONG } from 'shared/react-query/query-defaults';

export const useGetEmployeeDetail = (employeeId: string = '') => {
  const queryFn = async () => await sharedWorkforceService.getEmployee(employeeId);

  return useQuery<Promise<EmployeeResponse>, Error, EmployeeResponse>(
    QUERY_KEYS.employee(employeeId),
    queryFn,
    {
      enabled: employeeId.length > 0,
      cacheTime: CACHE_TIME_LONG,
    }
  );
};
